import "antd/lib/empty/style";
import _Empty from "antd/lib/empty";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import "antd/lib/typography/style";
import _Typography from "antd/lib/typography";
var __jsx = React.createElement;
import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import relativeTimePlugin from 'dayjs/plugin/relativeTime';
import WorkResponseError from 'utils/errors/http/WorkResponseError';
import WorkGenericError from 'utils/errors/http/WorkGenericError';
import WorkTimeoutError from 'utils/errors/http/WorkTimeoutError';
var Text = _Typography.Text;
dayjs.extend(relativeTimePlugin);
var PlatformError = function PlatformError(props) {
  var description = props.description,
    error = props.error,
    actionable = props.actionable,
    onClick = props.onClick;
  var reason = props.reason;
  var _useState = useState('just now'),
    relativeTime = _useState[0],
    setRelativeTime = _useState[1];
  useEffect(function () {
    if (!(error !== null && error !== void 0 && error.timeout)) {
      return;
    }
    var interval = setInterval(function () {
      return setRelativeTime(dayjs(error.timeout).fromNow());
    }, 1000);
    return function () {
      clearInterval(interval);
    };
  }, []);
  var renderMessage = function renderMessage() {
    var _reason;
    reason = (_reason = reason) !== null && _reason !== void 0 ? _reason : 'That\'s all we know';
    if (error instanceof WorkResponseError) {
      reason = 'We had an error on our side while we were completing your request.';
    } else if (error instanceof WorkTimeoutError) {
      reason = __jsx(React.Fragment, null, "We were expecting your request to arrive", ' ', relativeTime, ", but we were too slow.", __jsx("br", null), "We stopped waiting so you can try again.");
    } else if (error instanceof WorkGenericError) {
      reason = error.message;
    }
    return __jsx(React.Fragment, null, __jsx(Text, {
      type: "primary"
    }, description || 'We\'re sorry, we couldn\'t load this. '), __jsx("br", null), __jsx(Text, {
      type: "secondary"
    }, reason));
  };
  return __jsx(_Empty, {
    image: __jsx("img", {
      alt: "A woman with a paintbrush staring at an empty canvas (illustration).",
      src: "/undraw_blank_canvas_3rbb.svg"
    }),
    imageStyle: {
      height: 120,
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '50%'
    },
    description: renderMessage(error)
  }, actionable ? __jsx(_Button, {
    type: "primary",
    onClick: onClick || window.location.reload()
  }, "Try again") : '');
};
PlatformError.defaultProps = {
  description: null,
  error: null,
  actionable: true,
  onClick: null,
  reason: null
};
export default PlatformError;